import { render } from "./OtpConfirmationForm.vue?vue&type=template&id=a950ced0"
import script from "./OtpConfirmationForm.vue?vue&type=script&lang=js"
export * from "./OtpConfirmationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__